<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
        >
            <template v-slot:item.flag="{ item }">
                <v-simple-checkbox v-model="item.valid_flag" disabled/>
            </template>
            <template v-slot:item.Btn="{ item }">
                <a
                    :class="{ 'disabled-btn': btn[3].isActive }"
                    @click="editModal(item)"
                    class="editBtn">変更</a>
            </template>
        </v-data-table>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="btn[2].isActive" color="green darken-4" text @click="addModalView">追加</v-btn>
        </v-card-actions>
        <GolfCourseModal
            ref="Modal"
            :edit-info="findData"
            @refresh-event="moldingAddress"
        ></GolfCourseModal>
    </div>
</template>

<script>
import { GET_GOLFCOURSE } from '../../../constants/master';
import GolfCourseModal from './modal/GolfCourseModal';
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        GolfCourseModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            golf_code: '',
            // v-data-tableのヘッダー
            headers: [
                { text: 'ゴルフ場コード', value: 'golf_code', sortable: false, align: 'center' },
                { text: 'ゴルフ場名', value: 'golf_name', sortable: false },
                { text: 'カナ', value: 'golu_kana', sortable: false },
                { text: '郵便番号', value: 'zip_code', sortable: false },
                { text: '住所', value: 'address', sortable: false },
                { text: '電話番号', value: 'telephone', sortable: false },
                { text: 'fax', value: 'fax', sortable: false },
                { text: '有効フラグ', value: 'flag', sortable: false },
                { text: '', value: 'Btn', sortable: false, align: 'center' }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0010'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.moldingAddress();
        },
        /** ----------------------------------------------
        * ゴルフグループを取得 dessertsの代入はmodingAddressで行う
        * ---------------------------------------------- */
        getGolfCourse () {
            return this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_GOLFCOURSE,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    limit_rows: this.limit_rows,
                    begin_row: this.begin_row
                }
            }).then(res => {
                const count = res.data.getGolfCourseByMaster.count;
                this.pageCount = Math.ceil(count / 10);
                return res.data.getGolfCourseByMaster.GolfCourse;
            }).catch(error => { this.error = error; });
        },
        /** ----------------------------------------------
        * 住所を成形してdessertsに代入
        * ---------------------------------------------- */
        moldingAddress () {
            this.getGolfCourse().then(res => {
                res.forEach(el => {
                    if (!el.local_name) el.local_name = '';
                    if (!el.building_name) el.building_name = '';
                    if (!el.company_name) el.company_name = '';
                    el.address = el.prefecture_name + el.municipality_name + el.local_name + el.building_name;
                    el.valid_flag = Boolean(el.valid_flag);
                });
                this.desserts = res;
            }).catch(error => { this.error = error; });
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * 子コンポーネントのmodalをtrueにして表示する
        * ---------------------------------------------- */
        addModalView () {
            this.$refs.Modal.addModal();
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/GolfCourseModal.vue'
        * -------------------------------------------- */
        editModal (item) {
            this.findData = this.desserts.find(ele => ele.golf_code === item.golf_code);
            this.$refs.Modal.editModal();
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.moldingAddress();
        }
    }
};
</script>

<style scoped>

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .v-data-table{
        display: block;
        overflow-x: scroll;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        width: 100%;
    }

    .v-data-table ::v-deep td{
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
    }

    .v-simple-checkbox{
        display: flex;
        justify-content: center;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
